import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PolicyRenewalItemQuotationContainer from './PolicyRenewalItemQuotationContainer';
import { CollapseCard, Typography } from '@totalsoft/rocket-ui';

const PolicyRenewalItemQuotationsComponent = ({ quotations, header, fetching }) => {
  const { t } = useTranslation();

  const running = useMemo(() => {
    return quotations.some(quotation => quotation.runningYN);
  }, [quotations]);

  const sortQuotations = useCallback(() => {
    return quotations.slice().sort((a, b) => {
      if (a.period < b.period) return -1;
      if (a.period > b.period) return 1;
      if (a.insurerName < b.insurerName) return -1;
      return 1;
    });
  }, [quotations]);

  const quotationsByPeriod = useMemo(() => {
    const sortedQuotations = sortQuotations();

    const result = sortedQuotations.reduce((acc, curr) => {
      if (!acc[curr.period]) acc[curr.period] = [];
      acc[curr.period].push(curr);
      return acc;
    }, []);

    return result;
  }, [sortQuotations]);

  return (
    quotations &&
    quotations.length > 0 && (
      <CollapseCard
        subheader={
          <Grid container>
            <Grid item xs={5}>
              <Typography variant='subtitle2' color='primary'>
                <strong>{t('Offer.PolicyRenewalList.Field.QuotationsDate')}:</strong> {t('DATE', { date: header.quotationsDate }) || '-'}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography variant='subtitle2' color='primary'>
                <strong>{t('Offer.PolicyRenewalList.Field.SentToClientDate')}:</strong>{' '}
                {t('DATE', { date: header.sentToClientDate }) || '-'}
              </Typography>
            </Grid>
          </Grid>
        }
        toggleOnHeaderClick
      >
        <Grid item container spacing={2} id={`quotations_${header.documentId}`} key={header.documentId}>
          {quotationsByPeriod &&
            quotationsByPeriod.map((quotation, period) => (
              <PolicyRenewalItemQuotationContainer quotation={quotation} key={period} fetching={fetching} running={running} />
            ))}
        </Grid>
      </CollapseCard>
    )
  );
};

PolicyRenewalItemQuotationsComponent.propTypes = {
  quotations: PropTypes.array,
  header: PropTypes.object,
  fetching: PropTypes.bool
};

export default PolicyRenewalItemQuotationsComponent;
